import {
  TbArrowsLeftRight,
  TbChevronsRight,
  TbCoins,
  TbCreditCard,
  TbFileText,
  TbQrcode,
  TbTicket,
  TbTransfer,
} from "react-icons/tb";
import intl from "react-intl-universal";
import { MdOutlinePix } from "react-icons/md";
import { ShortcutCard } from "../../Atoms/ShortcutCard";
import { useAuth } from "../../../Contexts/AuthContext";
import { STABLES_HOME_PATH } from "../../../Pages/Private/Stables/constants";
import { useIbProductFeaturesStore } from "../../../Stores/ibProductFeaturesStore";
import { isIbProductEnabled } from "../../../Utils/ibProductFeatures";

export const HomeQuickActions = ({ onOpenTransfer, onOpenQrReceive }) => {
  const { hasPermission } = useAuth();
  const features = useIbProductFeaturesStore((state) => state.features);

  const actions = [
    {
      labelKey: "words.pix",
      icon: MdOutlinePix,
      path: "/pix",
      permission: "pixview",
      requiredFeature: "pix",
    },
    {
      labelKey: "pix.receiveByQr",
      icon: TbQrcode,
      onClick: onOpenQrReceive,
      permission: "receivepix",
      requiredFeature: "pix",
    },
    {
      labelKey: "words.pay",
      icon: TbChevronsRight,
      path: "/pagamento",
      permission: "payboleto",
      comingSoon: true,
    },
    {
      labelKey: "words.transfer",
      icon: TbArrowsLeftRight,
      onClick: onOpenTransfer,
      permission: "transp2p",
    },
    {
      labelKey: "words.billet",
      icon: TbTicket,
      path: "/boletos",
      permission: "boletocreateview",
      comingSoon: true,
    },
    { labelKey: "words.extract", icon: TbFileText, path: "/extrato", permission: "statementsview" },
    {
      labelKey: "nav.stables",
      icon: TbCoins,
      path: STABLES_HOME_PATH,
      permission: "stablesview",
      requiredFeature: "stables",
    },
    { labelKey: "words.ted", icon: TbTransfer, permission: "p2pview", comingSoon: true },
    {
      labelKey: "words.cards",
      icon: TbCreditCard,
      path: "/cartoes",
      permission: "mycardview",
      requiredFeature: "cards",
    },
  ];

  const visible = actions.filter((action) => {
    if (action.permission && !hasPermission(action.permission)) return false;
    if (action.requiredFeature && !isIbProductEnabled(features, action.requiredFeature)) {
      return false;
    }
    if (action.comingSoon) return true;
    if (action.onClick) return typeof action.onClick === "function";
    return Boolean(action.path);
  });

  if (!visible.length) return null;

  return (
    <section className="mb-5 min-w-0 w-full max-w-full overflow-x-hidden">
      <p className="dashboard-section-label mb-3">
        {intl.get("dashboard.quickActions")}
      </p>
      <div className="shortcut-scroll-row">
        {visible.map(({ labelKey, icon, path, search, onClick, comingSoon }) => (
          <ShortcutCard
            key={labelKey}
            to={path}
            search={search}
            onClick={onClick}
            icon={icon}
            label={intl.get(labelKey)}
            disabled={comingSoon}
            badge={comingSoon ? intl.get("words.soon") : undefined}
          />
        ))}
      </div>
    </section>
  );
};
